<script setup lang="ts" generic="T extends Record<string, unknown>">
import type { Form } from './use-form';

const props = defineProps<{
  form: Form<T>;
  /**
   * Optional `id` for the underlying `<form>` element. Lets a submit button
   * rendered outside the form (e.g. a modal footer) associate with it via the
   * native HTML `form` attribute.
   */
  id?: string;
}>();

const emits = defineEmits<{
  submit: [value: T];
}>();

const onSubmit = props.form.vForm.handleSubmit((value) => {
  emits('submit', value);
});
</script>

<template>
  <form :id="props.id" @submit="onSubmit">
    <slot />
  </form>
</template>
